import React from "react";
import ReactDOM from "react-dom";
import "../../../../shared/styles/colorDefinitions.css";
import "../../../../merchant/panel/style.css";
import "./style.css";
import StatusIndex from "./StatusPage.js";
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(StatusIndex, null), document.getElementById("root"));
